const labels = {
  title: 'CB Plus Backdoor',
  cbplusBvLinking: 'CB Plus BV Linking',
}

export default labels
